import {SHOW_SNACK} from "../../constants/action-types";

export const showSnack = (text, snackType, show = true) => {

    return ({
        type: SHOW_SNACK,
        text: text,
        snackType: snackType,
        show: show
    });

};

export const snackTypes = {
    success: "success",
    warning: "warning",
    error: "error",
};
